import { Box, Typography } from "@mui/material";
import React from "react";
import { notesOptions, reporCptOptions } from "../../utils/helpers";
import { useSelector } from "react-redux";

const ReportCptCodeCards = ({
  selectedCptFilters,
  clickFilterHandler,
  padding = "16px 24px",
  smartSortEnabled,
}) => {
  const getCptCodeSummary = useSelector((state) => state.getCptCodeSummary);
  const { loading: loadingCptSummary, cptCodeSummary } = getCptCodeSummary;

  const cptCountMap = {};
  cptCodeSummary?.cpt_summary.forEach(({ cpt_code, count }) => {
    cptCountMap[cpt_code] = count;
  });

  return (
    <>
      {smartSortEnabled ? (
        <></>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          gap="8px"
          flexWrap="wrap"
          p={padding}
        >
          {reporCptOptions?.map((item, index) => (
            <Box
              key={index}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap="4px"
              padding="3px 10px"
              borderRadius="4px"
              bgcolor={
                selectedCptFilters?.includes(item?.value)
                  ? `${item?.bgColor}`
                  : "#F4F6F8"
              }
              color="#0D0D0D"
              sx={{
                boxShadow: selectedCptFilters?.includes(item?.value)
                  ? `inset 0 0 0 1.5px ${item.borderColor}`
                  : ``,
                "&:hover": {
                  background: `${item?.hoverBgColor}`,
                  color: "#fff !important",
                  transition: "background 300ms ease-out",
                },
                "&:hover .count": {
                  color: "#fff",
                },
                cursor: "pointer",
              }}
              onClick={
                loadingCptSummary ? null : () => clickFilterHandler(item?.value)
              }
            >
              <Typography variant="body2"> {item.title}</Typography>
              {!loadingCptSummary && item.value !== "all" && (
                <Typography
                  className="count"
                  variant="body2"
                  sx={{
                    color: "#566875",
                    transition: "color 300ms ease-out",
                  }}
                >
                  {" "}
                  ({cptCountMap[item.value]})
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};

export default ReportCptCodeCards;
